import { render, staticRenderFns } from "./medicion-severidad-ver.vue?vue&type=template&id=4e276bcf&scoped=true&"
import script from "./medicion-severidad-ver.vue?vue&type=script&lang=js&"
export * from "./medicion-severidad-ver.vue?vue&type=script&lang=js&"
import style0 from "./medicion-severidad-ver.vue?vue&type=style&index=0&id=4e276bcf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e276bcf",
  null
  
)

export default component.exports